/* eslint-disable */
import {
    InputAdornment,
    Paper,
    TableBody,
    TableCell,
    TableRow,
    Toolbar,
} from '@mui/material';
import { makeStyles } from '@mui/styles';
import { DeleteForeverOutlined, Search } from '@mui/icons-material';
import AddIcon from '@mui/icons-material/Add';
import EditOutlinedIcon from '@mui/icons-material/Edit';
import TuneIcon from '@mui/icons-material/Tune';
import RefreshIcon from '@mui/icons-material/Refresh';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Controls } from '../../components/controls/Controls';
import PageHeader from '../../components/PageHeader';
import Popup from '../../components/Popup';
import useTable from '../../components/useTable';
import {
    loadGenericParameters,
    saveGenericParameter,
} from '../../redux/ducks/genericParameters';
import GenericParametersForm from './GenericParametersForm';
import ConfirmDialog from '../../components/ConfirmDialog';
import http from '../../http-common';
import { filterOnAnyField } from '../../utils';

const useStyles = makeStyles((theme) => ({
    pageContent: {
        margin: theme.spacing(5),
        padding: theme.spacing(3),
    },
    searchInput: {
        width: '75%',
    },
}));

const headCells = [
    { id: 'id', label: 'ID' },
    { id: 'parameterName', label: 'Parameter Name' },
    { id: 'attributeSeqno', label: 'Seq No' },
    { id: 'attributeName', label: 'Attribute Name' },
    { id: 'attributeValue', label: 'Attribute Value' },
    { id: 'actions', label: 'Acciones', disableSorting: true },
];

export default function GenericParameters() {
    const [openPopup, setOpenPopup] = useState(false);
    const classes = useStyles();
    const [filterFn, setFilterFn] = useState({ fn: (items) => items });
    const [recordForEdit, setRecordForEdit] = useState();
    const [filter, setFilter] = useState('');

    const dispatch = useDispatch();
    const parameters = useSelector((state) => state.genericParameters.parameters);

    const {
        TblContainer,
        TblHead,
        TblPagination,
        recordsAfterPagingAndSorting,
    } = useTable(parameters, headCells, filterFn);

    useEffect(() => {
        dispatch(loadGenericParameters());
    }, [dispatch]);

    const handleSearch = (e) => {
        const { target } = e;
        setFilter(target.value);
        setFilterFn({
            fn: (items) => {
                if (target.value === '') return items;
                return filterOnAnyField(items, target.value.toLowerCase());
            },
        });
    };

    const addOrEdit = (parameter, resetForm) => {
        dispatch(saveGenericParameter(parameter));
        setOpenPopup(false);
        resetForm();
    };

    const openInPopup = (item) => {
        setRecordForEdit(item);
        setOpenPopup(true);
    };

    const [confirmDialog, setConfirmDialog] = useState({
        title: 'title',
        subtitle: 'subtitle',
        isOpen: false,
    });

    const deleteParameter = (item) => {
        setConfirmDialog({
            subtitle: '',
            title: '¿Desea borrar el parámetro?',
            isOpen: true,
            onConfirm: async () => {
                await http.delete(`/GenericParameters/${item.id}`);
                dispatch(loadGenericParameters());
                setConfirmDialog((prev) => ({ ...prev, isOpen: false }));
            },
        });
    };

    return (
        <>
            <PageHeader
                icon={<TuneIcon fontSize='large' />}
                subtitle=''
                title='Parámetros Genéricos'
            />
            <Paper className={classes.pageContent}>
                <Toolbar>
                    <Controls.Input
                        className={classes.searchInput}
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position='end'>
                                    <Search />
                                </InputAdornment>
                            ),
                        }}
                        label='Buscar'
                        onChange={handleSearch}
                        value={filter}
                    />
                    <Controls.Button
                        onClick={() => dispatch(loadGenericParameters())}
                        startIcon={<RefreshIcon />}
                        text='Refrescar'
                        variant='outlined'
                    />
                    <Controls.Button
                        onClick={() => {
                            setRecordForEdit(null);
                            setOpenPopup(true);
                        }}
                        startIcon={<AddIcon />}
                        text='Agregar Nuevo'
                        variant='outlined'
                    />
                </Toolbar>
                <TblContainer>
                    <TblHead />
                    <TableBody>
                        {recordsAfterPagingAndSorting().map((item) => (
                            <TableRow key={item.id}>
                                <TableCell>{item.id}</TableCell>
                                <TableCell>{item.parameterName}</TableCell>
                                <TableCell>{item.attributeSeqno}</TableCell>
                                <TableCell>{item.attributeName}</TableCell>
                                <TableCell>{item.attributeValue}</TableCell>
                                <TableCell>
                                    <Controls.ActionButton
                                        color='primary'
                                        onClick={() => openInPopup(item)}
                                    >
                                        <EditOutlinedIcon fontSize='small' />
                                    </Controls.ActionButton>
                                    <Controls.ActionButton
                                        color='primary'
                                        onClick={() => deleteParameter(item)}
                                    >
                                        <DeleteForeverOutlined fontSize='small' />
                                    </Controls.ActionButton>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </TblContainer>
                <TblPagination />
            </Paper>
            <Popup
                openPopup={openPopup}
                setOpenPopup={setOpenPopup}
                title='Parámetro Genérico'
            >
                <GenericParametersForm
                    addOrEdit={addOrEdit}
                    recordForEdit={recordForEdit}
                />
            </Popup>
            <ConfirmDialog
                confirmDialog={confirmDialog}
                setConfirmDialog={setConfirmDialog}
            />
        </>
    );
}
